// HowItWorksFullPage · broker version. The previous prop-firm page
// (EvaluationProcess + WhyOFunded + Payouts) has been retired in
// favour of the broker journey: open → verify & fund → trade on MT5.
// We reuse the live `OnboardingSteps` 3-card mockup and the
// `WhyOFinancialMarkets` differentiator block so the page stays
// consistent with the homepage funnel.
import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import OnboardingSteps from "@/components/OnboardingSteps";
import WhyOFinancialMarkets from "@/components/WhyOFinancialMarkets";
import CTABanner from "@/components/CTABanner";
import { PageBreadcrumb, RelatedLinks } from "@/components/SEOBlocks";
import PageHero from "@/components/PageHero";
import { Compass } from "lucide-react";

const HOW_RELATED = [
  { to: "/account-comparison", label: "Compare Accounts",      tagline: "Classic · Premier · Elite · Social" },
  { to: "/funding",            label: "Funding Methods",       tagline: "Card · wire · crypto" },
  { to: "/calculator",         label: "Trading Calculator",    tagline: "Pip · margin · P/L" },
  { to: "/platforms/mt5",      label: "MetaTrader 5",          tagline: "Our flagship platform" },
];

export default function HowItWorksFullPage() {
  const { t } = useTranslation();
  return (
    <div data-testid="page-how-it-works-full" className="relative overflow-x-hidden">
      <Navbar />
      <PageHero
        breadcrumb={[{ label: t("howItWorks.breadcrumb", "How It Works") }]}
        pill={{ Icon: Compass, text: t("howItWorks.pill", "How It Works") }}
        title={t("howItWorks.titlePart1", "From signup to first trade ·")}
        accent={t("howItWorks.titleAccent", "step by step")}
        subline={t("howItWorks.subtitle", "Opening an account at OFinancial Markets is a transparent three-step process. Open, fund and trade on MT5. Here is exactly how it works.")}
        primary={{ label: t("common.openAccount", "Open Account"),  to: "/account-comparison" }}
        secondary={{ label: t("howItWorks.fundingMethods", "Funding methods"), to: "/funding" }}
      />
      <main className="pb-20">
        <OnboardingSteps />
        <WhyOFinancialMarkets />

        <RelatedLinks items={HOW_RELATED} />
      </main>
      <CTABanner />
      <Footer />
    </div>
  );
}
